import { useCallback } from 'react';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import type { LegacyTrackSearchEventData } from './legacy-types';

interface UseLegacyTrackSearchVariables {
  urlParameters: string;
  searchData: LegacyTrackSearchEventData['searchData'];
}

export const createLegacyTrackSearch = (
  variables: UseLegacyTrackSearchVariables,
): LegacyTrackSearchEventData => {
  const eventData: LegacyTrackSearchEventData = {
    eventType: 'search',
    urlParameters: variables.urlParameters,
    searchData: variables.searchData,
  };

  return eventData;
};

export const useLegacyTrackSearch = () => {
  const { track } = useLegacyTracking();

  const trackLegacySearch = useCallback(
    (variables: UseLegacyTrackSearchVariables) => {
      track({
        event: 'search',
        data: createLegacyTrackSearch(variables),
      });
    },
    [track],
  );

  return {
    trackLegacySearch,
  };
};
